import { NaiveBookMeetingBlockConfigSchema } from './NaiveBookMeetingConfig.types';
import { CTABlockConfigSchema } from './CTAConfig.types';
import { EmbedBlockConfigSchema } from './EmbedConfig.types';
import { EmbeddedSnippetBlockConfigSchema } from './EmbeddedSnippetConfig.types';
import { FooterBlockConfigSchema } from './FooterConfig.types';
import { HeroBlockConfigSchema } from './HeroConfig.types';
import { LogoBarBlockConfigSchema } from './LogoBarConfig.types';
import { ValuePropBlockConfigSchema } from './ValuePropConfig.types';
import { MagicResourceBlockConfigSchema } from './MagicResourceLibraryConfig.types';
import { NavBarBlockConfigSchema } from './NavBarConfig.types';
import { ResourceLibraryBlockConfigSchema } from './ResourceLibraryConfig.types';
import { SpotlightBlockConfigSchema } from './SpotlightConfig.types';
import { TestimonialBlockConfigSchema } from './TestimonialConfig.types';
import { HeadBlockConfigSchema } from './HeadConfig.types';
import { PagePasswordBlockConfigSchema } from './PagePasswordConfig.types';
import { z } from 'zod';

export const BlockConfigSchema = z.discriminatedUnion('type', [
  HeroBlockConfigSchema,
  NavBarBlockConfigSchema,
  EmbedBlockConfigSchema,
  EmbeddedSnippetBlockConfigSchema,
  CTABlockConfigSchema,
  FooterBlockConfigSchema,
  LogoBarBlockConfigSchema,
  ValuePropBlockConfigSchema,
  ResourceLibraryBlockConfigSchema,
  MagicResourceBlockConfigSchema,
  TestimonialBlockConfigSchema,
  SpotlightBlockConfigSchema,
  HeadBlockConfigSchema,
  NaiveBookMeetingBlockConfigSchema,
  PagePasswordBlockConfigSchema,
]);

export type BlockConfig = z.infer<typeof BlockConfigSchema>;
